module.exports = __webpack_public_path__ + "img/btn-back.affc8f44.png";